import invariant from 'invariant';

export default (testValue: any, format?: string, ...extra: any[]) =>
  invariant(testValue, `[UI] ${format}`, ...extra);
